import { render, staticRenderFns } from "./SmsMapping.vue?vue&type=template&id=2d44cffe&"
import script from "./SmsMapping.vue?vue&type=script&lang=js&"
export * from "./SmsMapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports